"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var index_1 = require("../../../models/index");
var StreamComponent = /** @class */ (function () {
    function StreamComponent() {
    }
    StreamComponent.prototype.ngOnChanges = function (changes) {
        var change = changes.participant;
        if (change) {
            this.participant = change.currentValue;
            this.lastManager = this.participant.manager;
            this.subscribeToManager();
            this.setVideo();
        }
    };
    StreamComponent.prototype.subscribeToManager = function () {
        var _this = this;
        if (!this.participant) {
            return;
        }
        this.participant.managerChanges()
            .subscribe(function (manager) {
            if (manager) {
                _this.lastManager = _this.participant.manager;
                _this.setVideo();
            }
            else {
                console.log('dis associate video ....');
                _this.lastManager.disassociateVideo(_this.video.nativeElement);
            }
        });
    };
    StreamComponent.prototype.setVideo = function () {
        if (this.participant && this.participant.manager) {
            this.participant.manager.disassociateVideo(this.video.nativeElement);
            this.participant.manager.addVideoElement(this.video.nativeElement);
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", index_1.Participant)
    ], StreamComponent.prototype, "participant", void 0);
    __decorate([
        core_1.ViewChild('video', { read: core_1.ElementRef }),
        __metadata("design:type", core_1.ElementRef)
    ], StreamComponent.prototype, "video", void 0);
    StreamComponent = __decorate([
        core_1.Component({
            selector: 'sis-stream',
            template: require('./stream.component.html'),
            styles: [require('./stream.component.css')]
        })
    ], StreamComponent);
    return StreamComponent;
}());
exports.StreamComponent = StreamComponent;
//# sourceMappingURL=stream.component.js.map